<div class="card">
  <div class="card-body">
    <div class="p-3">
      <div class="row">
        <div class="col-lg-4" >
          <input [(ngModel)]="cerca" placeholder="Cerca" type="text" name="quantita" class="form-control">
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Blocco</th>
            <th scope="col">Contenuto</th>
            <th scope="col">Testo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Blocchi | CercaFilter: cerca">
            <td class="py-4"> <input type="checkbox" [ngModel]="item.checked" name="list_name" (ngModelChange)="Check(item,$event)"/> </td>
            <td class="align-middle"> {{item.nome}} </td>
            <td class="align-middle">
              <ng-multiselect-dropdown [disabled]="!item.modifica"  [settings]="DropdownSettings" [placeholder]="'Contenuto'" [data]="item.contenutiList" [(ngModel)]="item.contenuto" (ngModelChange)="ContenutoChange(item, $event)"></ng-multiselect-dropdown>
            </td>
            <td class="align-middle"> <textarea [(ngModel)]="item.testo" placeholder="Testo" type="text" rows="3" name="quantita" class="form-control"></textarea> </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
